//Created by wangshuyi on 2021/7/21.

'use strict';

let dolphinCoreConfig = {};
// request
dolphinCoreConfig.ajax = {
    forceUrl: false,
    showMessage: true,
    loadingTimeout: true,
    i18nHeader: true,
    checkResult: (data) => data.success,
    encodeToken: token => token,
}
dolphinCoreConfig.erp = {
    forceUrl: false,
    method: 'post',
    showMessage: true,
    loadingTimeout: true,
}
dolphinCoreConfig.socket = {
    showMessage: true,
    waitTime: 200,
    maxCount: 3
}

//core
dolphinCoreConfig.dolBoolean = {
    trueText: '是',
    falseText: '否',
    nullText: '',
}
dolphinCoreConfig.isoDate = {
    dateFormat: 'YYYY-MM-DD',
    datetimeFormat: 'YYYY-MM-DD HH:mm:ss',
}
dolphinCoreConfig.pathDetail = {
    separation: ' / ',
    labelField: 'name',
}
dolphinCoreConfig.validate = {
    isEmail: (val) => /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(val),
}

//dict
dolphinCoreConfig.dict = {
    ajaxFlag: true,
    server: '/system/dict/options/{code}',     // /system/dict/options/{code} | /GetSysDic
    serverType: 'NodeJs',           // NodeJs | DotNet
    labelField: 'text',
}

//dol-i18n
dolphinCoreConfig.i18n = {
    prefix: '',
    suffix: '_en',
}
dolphinCoreConfig.dolPrice = {
    toFixed: 2,
    defaultColor: '#000000',
    defaultSize: '14px',
    intColor: '#1890ff',
    intSize: '20px',
    unit: '￥',
}

//dol-icon
dolphinCoreConfig.iconMap = {};

export default dolphinCoreConfig;
